// const BASE_URL = "https://vclive.prod-rasiinfotech.in";
// 
const BASE_URL = "https://billing.mgdm.in";

// const BASE_URL = "http://103.58.115.111:5300";

// const BASE_URL = "https://zinger.prod-rasiinfotech.in";

const WEB_URL  = "https://mgdm.in";

// const WEB_URL = "https://108mahavel.in"

// const BASE_URL = "https://MGDM.prod-rasiinfotech.in";

// const WEB_URL  = "https://vclive.prod-rasiinfotech.in";

// const BASE_URL = "https://froads.trysumangaleejewellers.in";


export { BASE_URL , WEB_URL};
